/**
 * Singleton bridge to the timeline's <audio> element.
 *
 * The HTMLAudioElement lives inside Timeline.tsx (it owns the Web Audio
 * graph + the watchdog) but other components — the Pattern Difficulty
 * heatmap, keyboard shortcuts, the 3D viewport — also need to seek to a
 * given time and have the audio actually move with the store.
 *
 * Timeline registers/unregisters the element on mount/unmount; callers
 * use `seekAudio(time)` to imperatively move the playhead.
 */

let audioElement: HTMLAudioElement | null = null;

export function registerAudioElement(el: HTMLAudioElement | null): void {
  audioElement = el;
}

/**
 * Move the audio playhead to `timeSeconds`. Safe to call when audio isn't
 * registered yet (no-op) or when timeSeconds is out of bounds (clamped to
 * [0, audio.duration]).
 */
export function seekAudio(timeSeconds: number): void {
  if (!audioElement) return;
  const dur = audioElement.duration;
  const t = Number.isFinite(dur) && dur > 0
    ? Math.max(0, Math.min(timeSeconds, dur))
    : Math.max(0, timeSeconds);
  audioElement.currentTime = t;
}

export function getRegisteredAudio(): HTMLAudioElement | null {
  return audioElement;
}
